import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import ContractorAuthenticationModal from '../../../../components/family-plaza/ContractorAuthenticationModal';
import PortraitPhotoRegistrationModal from '../../../../components/PortraitPhotoRegistrationModal';
import { checkModalAuthenticationStatus } from '../../../../utils/authUtils';
import { getCurrentUserProfilePhoto, getCurrentCustomerName, setupProfilePhotoListener, getDeceasedPersonDate, getDeceasedPersonProfileText } from '../../../../utils/profilePhotoUtils';
import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';  
import DeceasedPersonProfile from '../../../../components/family-plaza/DeceasedPersonProfile';  

const MemorialPostDetailsMobile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [memorialPostData, setMemorialPostData] = useState(null);
  const [enteredPassword, setEnteredPassword] = useState('');
  const [isPasswordCorrect, setIsPasswordCorrect] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState('/mobile donate/group-129.png');
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleWritePost = () => {
    navigate('/memorial-post-writing');
  };

  const handleWriteButton = () => {
    navigate('/memorial-post-writing');
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  const handleMemorialPost = () => {
    navigate('/cyber-memorial-search');
  };

  const handleLetterToHeaven = () => {
    navigate('/letter-to-heaven-board-list');
  };

  const handleManagementInquiry = () => {
    navigate('/management-search');
  };

  const handleAncestralTablet = () => {
    navigate('/ancestral-tablet');
  };

  // Load memorial post data from localStorage
  useEffect(() => {
    const savedData = localStorage.getItem('selectedMemorialPost');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setMemorialPostData(parsedData);
      } catch (error) {
        console.error('Error parsing memorial post data:', error);
      }
    }
  }, []);

  // Load profile photo and listen for updates
  useEffect(() => {
    const loadProfilePhoto = () => {
      const photoUrl = getCurrentUserProfilePhoto();
      if (photoUrl) {
        setProfilePhotoUrl(photoUrl);
      }
    };

    loadProfilePhoto();

    // Set up profile photo listener
    const customerName = getCurrentCustomerName();
    const cleanup = setupProfilePhotoListener(setProfilePhotoUrl, customerName);

    return cleanup;
  }, []);

  // Get current user name for display
  const getCurrentUserName = () => {
    const selectedPersonData = localStorage.getItem('selectedPersonData');
    if (selectedPersonData) {
      try {
        const personData = JSON.parse(selectedPersonData);
        return personData.customerName || '이추모';
      } catch (error) {
        return '이추모';
      }
    }
    return '이추모';
  };

  // Handle password verification
  const handlePasswordSubmit = (passwordToCheck) => {
    const password = passwordToCheck || enteredPassword;
    
    if (memorialPostData && password === memorialPostData.password) {
      setIsPasswordCorrect(true);
      setShowPasswordError(false);
    } else {
      setIsPasswordCorrect(false);
      setShowPasswordError(true);
    }
  };

  // Photo icon click handler
  const handlePhotoIconClick = () => {
    if (checkModalAuthenticationStatus()) {
      setShowPhotoModal(true);
    } else {
      setShowAuthModal(true);
    }
  };

  // Authentication modal handlers
  const handleAuthConfirm = () => {
    setShowAuthModal(false);
    setShowPhotoModal(true);
  };

  const handleAuthClose = () => {
    setShowAuthModal(false);
  };

  // Photo registration modal handlers
  const handlePhotoConfirm = () => {
    setShowPhotoModal(false);
  };

  const handlePhotoUpload = (photoUrl) => {
    setProfilePhotoUrl(photoUrl);
  };

  const handlePhotoClose = () => {
    setShowPhotoModal(false);
  };

  // Handle action buttons
  const handleListButton = () => {
    navigate('/memorial-post-board-list');
  };

  const handleModifyButton = () => {
    if (isPasswordCorrect) {
      // Navigate to writing page for modification
      navigate('/memorial-post-writing');
    }
    // If password is incorrect, do nothing (button is disabled anyway)
  };

  const handleDeleteButton = () => {
    if (isPasswordCorrect && memorialPostData) {
      // Get customer name from localStorage
      const selectedPersonData = localStorage.getItem('selectedPersonData');
      let customerName = 'default';
      
      if (selectedPersonData) {
        try {
          const personData = JSON.parse(selectedPersonData);
          customerName = personData.customerName || 'default';
        } catch (error) {
          customerName = 'default';
        }
      }
      
      // Get existing posts and remove the selected post
      const postsKey = `memorialPosts_${customerName}`;
      const existingPosts = localStorage.getItem(postsKey);
      
      if (existingPosts) {
        try {
          const posts = JSON.parse(existingPosts);
          const updatedPosts = posts.filter(post => post.id !== memorialPostData.id);
          localStorage.setItem(postsKey, JSON.stringify(updatedPosts));
          
          // Dispatch event to notify other components
          window.dispatchEvent(new CustomEvent('memorialPostUpdated', {
            detail: {
              customerName: customerName,
              postData: null
            }
          }));
        } catch (error) {
          console.error('Error updating posts:', error);
        }
      }
      
      // Clear the selected post data
      localStorage.removeItem('selectedMemorialPost');
      // Navigate back to the list
      navigate('/memorial-post-board-list');
    }
    // If password is incorrect, do nothing (button is disabled anyway)
  };

  return (
    <div className="memorial-post-details-mobile-unique announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="사이버추모관" />
      
        <DeceasedPersonProfile  handlePhotoIconClick={handlePhotoIconClick}  />

      {/* Navigation Tabs */}
      <div className="memorial-post-details-mobile-nav-tabs-unique">
        <button 
          className="memorial-post-details-mobile-nav-tab-unique"
          onClick={() => navigate('/donate')}
        >
          <span>헌화하기</span>
        </button>
        <button 
          className="memorial-post-details-mobile-nav-tab-unique memorial-post-details-mobile-nav-tab-active-unique"
          onClick={() => navigate('/memorial-post-board-list')}
        >
          <span>추모글</span>
        </button>
        <button 
          className="memorial-post-details-mobile-nav-tab-unique"
          onClick={() => navigate('/memorial-album-board-list')}
        >
          <span>추모앨범</span>
        </button>
      </div>

      {/* Memorial Post Details Content */}
      <div className="memorial-post-details-mobile-content-unique">
        {/* Post Header */}
        <div className="memorial-post-details-mobile-post-header-unique">
          <div className="memorial-post-details-mobile-post-title-unique">
            {memorialPostData ? memorialPostData.title : '보고픈 울 엄마'}
          </div>
          <div className="memorial-post-details-mobile-post-sender-unique">
            From {memorialPostData ? (memorialPostData.writerName || getCurrentUserName()) : '이추모'} | {memorialPostData ? 
              new Date(memorialPostData.date).toLocaleDateString('ko-KR', { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit' 
              }).replace(/\. /g, '.').replace(/\.$/, '') 
              : '2018.05.02'
            }
          </div>
        </div>

        {/* Post Content Card */}
        <div className="memorial-post-details-mobile-post-card-unique">
          <div className="memorial-post-details-mobile-post-content-unique">
            {memorialPostData ? (
              <div>
                {memorialPostData.content.split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {index < memorialPostData.content.split('\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </div>
            ) : (
              <>
                어머니, 맑은 봄날입니다.<br />
                세월이 갈수록 당신의 은혜를 갚을 길이 없어 불효자가 됩니다.<br />
                지금의 행복도 다 당신 덕분입니다.<br />
                당신의 희생이 오늘을 만들어 주셨습니다.<br />
                고맙습니다.<br />
                그리고 죄송합니다.<br />
                다시 한 번 돌아갈 수 있다면<br />
                어머님께 많은 것을 해드릴 수 있을텐데...<br />
                보고 싶습니다. 어머니...
              </>
            )}
          </div>
        </div>

        {/* Separator */}
        <div className="memorial-post-details-mobile-separator-unique"></div>

        {/* Password Input Section */}
        <div className="memorial-post-details-mobile-password-section-unique">
          <label className="memorial-post-details-mobile-password-label-unique">
            비밀번호
          </label>
          <input 
            type="password" 
            className="memorial-post-details-mobile-password-input-unique"
            placeholder=""
            value={enteredPassword}
            onChange={(e) => {
              setEnteredPassword(e.target.value);
              // Auto-check password as user types
              if (e.target.value.length > 0) {
                handlePasswordSubmit(e.target.value);
              } else {
                setIsPasswordCorrect(false);
                setShowPasswordError(false);
              }
            }}
          />
        </div>

        {/* Action Buttons */}
        <div className="memorial-post-details-mobile-action-buttons-unique">
          <button 
            className="memorial-post-details-mobile-list-button-unique"
            onClick={handleListButton}
          >
            목록
          </button>
          <button 
            className="memorial-post-details-mobile-modify-button-unique"
            onClick={handleModifyButton}
            disabled={!isPasswordCorrect}
            style={{ 
              opacity: isPasswordCorrect ? 1 : 0.5,
              cursor: isPasswordCorrect ? 'pointer' : 'not-allowed'
            }}
          >
            수정
          </button>
          <button 
            className="memorial-post-details-mobile-delete-button-unique"
            onClick={handleDeleteButton}
            disabled={!isPasswordCorrect}
            style={{ 
              opacity: isPasswordCorrect ? 1 : 0.5,
              cursor: isPasswordCorrect ? 'pointer' : 'not-allowed'
            }}
          >
            삭제
          </button>
        </div>
      </div>

      {/* Authentication Modal */}
      <ContractorAuthenticationModal
        isOpen={showAuthModal}
        onConfirm={handleAuthConfirm}
        onClose={handleAuthClose}
      />

      {/* Photo Registration Modal */}
      <PortraitPhotoRegistrationModal
        isOpen={showPhotoModal}
        onConfirm={handlePhotoConfirm}
        onClose={handlePhotoClose}
        onPhotoUpload={handlePhotoUpload}
      />
      </main>
    </div>
  );
};

export default MemorialPostDetailsMobile; 